import { NewTeam, Team, TeamMember } from "models/common"

import { http } from "./http"

export const fetchUnassignedMembers = async (_key: string, params?: string) => {
  const searchParams = new URLSearchParams(params)
  const res = await http.get(`users/unassigned`, { searchParams }).json()
  return res as TeamMember[]
}

export const createTeam = async (pld: NewTeam) => {
  const json = pld
  const res = await http.post("teams", { json }).json()
  return res as Team
}

export const deleteTeam = async (teamId: string) =>
  await http.delete(`teams/${teamId}`)

export const fetchTeams = async (_key: string, params?: string) => {
  const searchParams = new URLSearchParams(params)
  const res = await http.get("teams", { searchParams }).json()
  return res as Team[]
}

export const fetchTeam = async (_key: string, id?: string): Promise<Team> =>
  await http(`teams/${id}`).json()

export const fetchAgencyClientTeams = async (
  _key: string,
  clientId: string,
  agencyId?: string,
  params?: string,
) => {
  const searchParams = new URLSearchParams(params)
  const res = await http
    .get(`agencies/${agencyId}/clients/${clientId}/teams`, { searchParams })
    .json()

  return res as Team[]
}

export const fetchClientConfigTeams = async (
  _key: string,
  clientId: string,
  _agencyId?: string,
) => {
  const res = await http.get(`client-agency-configs/${clientId}/teams`).json()

  return res as Team[]
}

export const addAgencyClientTeam = async ({
  agencyId,
  clientId,
  teamIds,
}: {
  agencyId: string
  clientId: string
  teamIds: string[]
}) => {
  const res = await http
    .post(`agencies/${agencyId}/clients/${clientId}/teams`, {
      json: { teamIds },
    })
    .json()

  return res as any
}

export const deleteAgencyClientTeam = async ({
  clientId,
  teamId,
  agencyId,
}: {
  clientId: string
  teamId: string
  agencyId?: string
}) => {
  const res = await http
    .delete(`agencies/${agencyId}/clients/${clientId}/teams/${teamId}`)
    .json()

  return res as any
}

export const deleteAgencyTeamMember = async ({
  teamId,
  memberId,
}: {
  teamId: string
  memberId: string
}) => {
  const res = await http.delete(`teams/${teamId}/members/${memberId}`).json()

  return res as any
}

export const addAgencyTeamMember = async ({
  teamId,
  memberId,
}: {
  teamId: string
  memberId: string
}) => {
  const res = await http
    .post(`teams/${teamId}/members`, { json: { userIds: [memberId] } })
    .json()

  return res as any
}
